import { apiReq } from "../utils/api/apiReq";

export async function signOut() {
	await apiReq("POST", "/v1/signOut");
}
